export default __webpack_public_path__ + "static/media/usa.fe0725bd.svg";